import { use } from "react";

export const isLucieVUser = (user) => {
  if (!user) return false;
  return user?.UserName === 'LucieV' ||
         user?.UserName === 'DidiP' ||
         user?.UserName === 'Yael' ||
         user?.UserName === 'EttiW' ||
         user?.UserName === 'Ashley' ||
         user?.UserName === 'ChenW' ||
         user?.UserName === 'GKirsh' ||
         user?.UserName === 'GittyM' ||
         user?.UserName === 'MayaH' ||
         user?.UserName === 'Noga';
};


export const CLOVER_ALLOWED_USERS = [
  'luciev', 
  'didip',
  'noga',
  'gkirsh', 
  'ashley', 
  'chenw', 
  'ettiw', 
  'yael',
  'gittym',
  'mayah',
  'tehilapomona'
];

export const ADMIN_ALLOWED_USERS = [
  'ettiw',
  'chenw',
  'rachelg',
  'didip',
  'noga',
];

//orderslist remove customer link from table
export const restrictedUserList = [
  'RachelG', 
  'Amberrose', 
  'Office',
  'Wash&Set', 
  'ShiraL'
];
